import jQuery from 'jquery';
import utils from './utils';
import header from './header';
import blocks from './blocks';
import staff from './staff';
import marketoForms from './marketo-forms';
import insights_filter from './insights-filter';
import offcanvas from './offcanvas';
import pageNavigation from './page-navigation';

jQuery(function(){
	utils();
	header();
	blocks();
	staff();
	marketoForms();
	insights_filter();
	offcanvas();
	pageNavigation();
});